import type { CSSProperties, ReactNode } from "react";
import { cn } from "../utils/cx.js";

export interface FlexProps {
  vertical?: boolean;
  align?: CSSProperties["alignItems"];
  justify?: CSSProperties["justifyContent"];
  gap?: number | "small" | "middle" | "large";
  wrap?: boolean;
  flex?: CSSProperties["flex"];
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

const NAMED_GAP = { small: 8, middle: 16, large: 24 } as const;

export function Flex({ vertical, align, justify, gap, wrap, flex, className, style, children }: FlexProps) {
  const gapValue = gap == null ? undefined : typeof gap === "number" ? gap : NAMED_GAP[gap];
  return (
    <div
      className={cn("flex", vertical && "flex-col", wrap && "flex-wrap", className)}
      style={{ alignItems: align, justifyContent: justify, gap: gapValue, flex, ...style }}
    >
      {children}
    </div>
  );
}
